import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  PledgeDocumentRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '../../services/FormGroupArray';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

export abstract class EaDocumentFormBuilder extends PrFormAbstract {
  isConsultant: boolean;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
    protected authenticationService: AuthentificationService,
  ) {
    super(formConstructor);
    authenticationService.isConsultant().subscribe(consultant => {
      this.isConsultant = consultant;
    });
  }

  generateForm(entity: PledgeDocumentRead, option: Parameters) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        ownerId: [entity?.ownerId],
        userLastName: [entity?.userLastName || null],
        userFirstName: [entity?.userFirstName || null],
        documents: this.formBuilder.group({
          id: [entity?.documents?.id || null],
          label: [entity?.documents?.label || null],
          document: [entity?.documents?.document || null, Validators.required],
          //cniNumber: [entity?.documents?.cniNumber || null],
          cniNumber: [entity?.cniNumber || null],
          dateExpired: [
            entity?.documents?.dateExpired || null,
            Validators.required,
          ],
        }),

        accountId: [entity ? entity?.accountId : null],
      },
      options,
    );
  }
  generate(entity: any, option) {
    const form = FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });

    return form;
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  get documentsControles() {
    return this.owners.controls.map(control => control.get('documents'));
  }

  extractDocument(owner?: any) {
    const pledge = this.subscriptionFacade.getPledge();

    let uploadForm: UntypedFormGroup;

    const ownerId = !owner.physicalUser ? owner.userId : owner.ownerId;

    uploadForm = this.formBuilder.group({
      ownerIds: this.utilsService.emptyIsNull([ownerId]),
      category: 'CIVIL_STATE',
      document: this.utilsService.emptyIsNull(owner.document),
      dateExpired: this.utilsService.emptyIsNull(owner.dateExpired),
      accountId: this.utilsService.emptyIsNull(pledge.accountId),
      id: this.utilsService.emptyIsNull(owner.id),
      label: this.utilsService.emptyIsNull(owner.label),
      dateCreated: owner.documents
        ? this.utilsService.emptyIsNull(owner.documents.dateCreated)
        : null,
      reviewed: !!this.isConsultant,
      isSigned: false,
    });
    return uploadForm;
  }
}
